module.exports = __webpack_public_path__ + "c3baa807cedb537f70ebd01bb42ad443.pdf";